export default "__VITE_ASSET__9536ad8d__"